import _classCallCheck from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\projects\\personal-portfolio\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { getRandom, getRangeValue } from "tsparticles-engine";
import { Wobble } from "./Options/Classes/Wobble";

function updateWobble(particle, delta) {
  var _a;

  var wobble = particle.options.wobble;

  if (!(wobble === null || wobble === void 0 ? void 0 : wobble.enable) || !particle.wobble) {
    return;
  }

  var angleSpeed = particle.wobble.angleSpeed * delta.factor,
      moveSpeed = particle.wobble.moveSpeed * delta.factor,
      distance = moveSpeed * (((_a = particle.retina.wobbleDistance) !== null && _a !== void 0 ? _a : 0) * delta.factor) / (1000 / 60),
      max = 2 * Math.PI;
  particle.wobble.angle += angleSpeed;

  if (particle.wobble.angle > max) {
    particle.wobble.angle -= max;
  }

  particle.position.x += distance * Math.cos(particle.wobble.angle);
  particle.position.y += distance * Math.abs(Math.sin(particle.wobble.angle));
}

export var WobbleUpdater = /*#__PURE__*/function () {
  function WobbleUpdater(container) {
    _classCallCheck(this, WobbleUpdater);

    this.container = container;
  }

  _createClass(WobbleUpdater, [{
    key: "init",
    value: function init(particle) {
      var _a;

      var wobbleOpt = particle.options.wobble;

      if (wobbleOpt === null || wobbleOpt === void 0 ? void 0 : wobbleOpt.enable) {
        particle.wobble = {
          angle: getRandom() * Math.PI * 2,
          angleSpeed: getRangeValue(wobbleOpt.speed.angle) / 360,
          moveSpeed: getRangeValue(wobbleOpt.speed.move) / 10
        };
      } else {
        particle.wobble = {
          angle: 0,
          angleSpeed: 0,
          moveSpeed: 0
        };
      }

      particle.retina.wobbleDistance = getRangeValue((_a = wobbleOpt === null || wobbleOpt === void 0 ? void 0 : wobbleOpt.distance) !== null && _a !== void 0 ? _a : 0) * this.container.retina.pixelRatio;
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      var _a;

      return !particle.destroyed && !particle.spawning && !!((_a = particle.options.wobble) === null || _a === void 0 ? void 0 : _a.enable);
    }
  }, {
    key: "loadOptions",
    value: function loadOptions(options) {
      if (!options.wobble) {
        options.wobble = new Wobble();
      }

      for (var _len = arguments.length, sources = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
      }

      for (var _i = 0, _sources = sources; _i < _sources.length; _i++) {
        var source = _sources[_i];
        options.wobble.load(source === null || source === void 0 ? void 0 : source.wobble);
      }
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateWobble(particle, delta);
    }
  }]);

  return WobbleUpdater;
}();